    <div class="booking-edit">
      <div class="page-header">
        <button mat-icon-button (click)="goBack()" aria-label="Назад">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="page-title">Редактирование брони #{{ bookingId }}</h1>
      </div>

      <div *ngIf="loading" class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <form *ngIf="!loading" [formGroup]="form" (ngSubmit)="onSubmit()" class="booking-form">
        <mat-card class="form-card">
          <mat-card-content>
            <app-datetime-input
              formControlName="startDate"
              dateLabel="Дата начала"
              timeLabel="Время"
              [required]="true">
            </app-datetime-input>

            <app-datetime-input
              formControlName="endDate"
              dateLabel="Дата окончания"
              timeLabel="Время"
              [required]="true">
            </app-datetime-input>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Залог, ₽</mat-label>
              <input matInput type="text" formControlName="depositAmount" placeholder="0.00">
              <mat-error *ngIf="form.get('depositAmount')?.hasError('pattern')">Введите число (например 1000.00)</mat-error>
              <mat-error *ngIf="form.get('depositAmount')?.hasError('serverError')">{{form.get('depositAmount')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Сумма аренды, ₽</mat-label>
              <input matInput type="text" formControlName="rentalAmount" placeholder="0.00">
              <mat-error *ngIf="form.get('rentalAmount')?.hasError('pattern')">Введите число (например 1000.00)</mat-error>
              <mat-error *ngIf="form.get('rentalAmount')?.hasError('serverError')">{{form.get('rentalAmount')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Заметки</mat-label>
              <textarea matInput formControlName="notes" rows="3"></textarea>
              <mat-error *ngIf="form.get('notes')?.hasError('serverError')">{{form.get('notes')?.getError('serverError')}}</mat-error>
            </mat-form-field>
          </mat-card-content>
        </mat-card>

        <button mat-raised-button color="primary" type="submit" class="full-width-btn"
                [disabled]="form.invalid || submitting">
          <mat-spinner *ngIf="submitting" diameter="20"></mat-spinner>
          <span *ngIf="!submitting"><mat-icon>save</mat-icon> Сохранить</span>
        </button>
      </form>
    </div>
